import { Button, Form, Modal } from "react-bootstrap"

const SegmentVisualizer = ({ segment, showModal, setShowModal }) => {
    return (
        <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
    >
        <Modal.Header closeButton>
            <Modal.Title className="text-muted">Segmento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                <Form.Group className="mb-3">
                    <Form.Label className="text-muted">Nombre del segmento</Form.Label>
                    <Form.Control
                        type="text"
                        value={segment?.nombre}
                        readOnly
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Empleados:</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={9}
                        value={segment?.list_empleados?.map(emp => `${emp.codigo}/${emp.nombre}`).join(', ') || "No hay empleados asignados."}
                        readOnly
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Empresas:</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={9}
                        value={segment?.list_empresas?.map(emp => `${emp.codigo}/${emp.nombre}`).join(', ') || "No hay empresas asignados."}
                        readOnly
                    />
                </Form.Group>
               
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button
                variant="secondary"
                onClick={() => setShowModal(false)}  
                className="rounded-pill"              
            >
                Cerrar
            </Button>
        </Modal.Footer>

    </Modal>
    )
}

export default SegmentVisualizer